import React, { useState } from "react";
// import arianaImage from "../../images/iserenify/iserenify_ariana_image_circle.JPEG";
import arianaImage from "../../images/my-story/my_story_ariana.jpeg";
import AdminImageZoom from "../AdminImageZoom";
import MainPageTextEditor, {
  FormattedMainPageText,
  useMainPageText,
} from "../MainPageTextEditor";
import "./style.css";

const DEFAULT_TEXT = {
  introOne:
    "Îți mulțumesc că alegi să îmi citești **povestea**.\nTotul a început într-o perioadă în care nu mă mai regăseam pe mine însămi. Timp de doi ani, m-am confruntat cu anxietate severă, atacuri de panică, depresie și insomnie. Au fost doi ani în care am încercat tot ce se putea încerca - tratamente, terapii, remedii, soluții rapide.",
  introTwo:
    "În tot acest timp, m-am **îndepărtat** de oamenii dragi mie. Nu mai eram eu. Trăiam în modul de **supraviețuire**.\nChiar și cele mai simple lucruri deveniseră dificile. O simplă ieșire la cumpărături putea declanșa un atac de panică, iar pentru că trăiam constant cu această **teamă**, am ales să mă izolez complet.",
  expandedOne:
    "Deși medicii îmi spuneau că sunt bine, **sufletul meu** simțea altceva.",
  expandedTwo:
    "În noiembrie 2022, am descoperit **uleiurile esențiale**. La început, cu scepticism. Apoi, cu speranță. Iar în scurt timp, cu profundă **recunoștință**.\nPicătură cu picătură, am început să mă reconectez cu mine. Să dorm. Să respir liniștită. Să ies din casă fără teamă. Să simt din nou **viața**.",
  expandedThree:
    "Lavanda și tămâia au devenit mai mult decât simple arome — au fost începutul unei **transformări** interioare. O invitație către echilibru, conștientizare și vindecare autentică.",
  expandedFour:
    "Unii îi spun noroc. Alții placebo.\nEu îi spun **cunoaștere**.",
  expandedFive:
    "*The oils babe* s-a născut din propria mea călătorie de vindecare. Cu entuziasm și recunoștință, am început să **împărtășesc** povestea mea cu cei din jur. Și atunci am realizat că experiența mea poate aduce **speranță** și altor oameni.",
  expandedSix:
    "Având o facultate și un master în psihologie, știam deja să ascult oamenii. Însă abia acum am simțit că pot să îi înțeleg cu adevărat și să îi ajut dintr-un loc profund, autentic și plin de empatie.",
  expandedSeven:
    "Astăzi, misiunea mea este să ofer mai departe ceea ce pe mine m-a ajutat să mă regăsesc: educație holistică și puterea micilor alegeri făcute cu **blândețe** și **intenție**.",
  expandedEight:
    "Pentru că uneori, *vindecarea începe exact când alegem să ne ascultăm cu adevărat*.",
};

const TEXT_FIELDS = [
  { key: "introOne", label: "Paragraf introductiv 1", rows: 5 },
  { key: "introTwo", label: "Paragraf introductiv 2", rows: 5 },
  { key: "expandedOne", label: "Text extins 1" },
  { key: "expandedTwo", label: "Text extins 2", rows: 5 },
  { key: "expandedThree", label: "Text extins 3" },
  { key: "expandedFour", label: "Text extins 4" },
  { key: "expandedFive", label: "Text extins 5", rows: 4 },
  { key: "expandedSix", label: "Text extins 6", rows: 4 },
  { key: "expandedSeven", label: "Text extins 7", rows: 4 },
  { key: "expandedEight", label: "Text extins 8" },
];

const BloomAbout = () => {
  const [expanded, setExpanded] = useState(false);
  const [content, setContent] = useMainPageText("about", DEFAULT_TEXT);

  return (
    <section className="new-about main-page-text-editable">
      <MainPageTextEditor
        section="about"
        sectionLabel="Despre mine"
        fields={TEXT_FIELDS}
        value={content}
        onSaved={setContent}
      />
      <div className="new-about__inner">
        <div className="new-about__header">
          <span className="new-about__pre-title">
            POVESTEA MEA
          </span>
          <h2 className="new-about__title">Despre mine</h2>
          <p className="new-about__subtitle">o călătorie spre wellness</p>
        </div>

        <div className="new-about__content">
          <div className="new-about__image-col">
            <AdminImageZoom
              settingKey="aboutImageScale"
              imageKey="aboutImage"
              src={arianaImage}
              alt="Ariana Henzel"
              frameClassName="new-about__image-wrap"
            />
          </div>
          <div className="new-about__text-col">
            <p className="new-about__text">
              <FormattedMainPageText text={content.introOne} />
            </p>
            <p className="new-about__text">
              <FormattedMainPageText text={content.introTwo} />
            </p>

            {expanded && (
              <div className="new-about__expanded">
                <p className="new-about__text">
                  <FormattedMainPageText text={content.expandedOne} />
                </p>
                <p className="new-about__text">
                  <FormattedMainPageText text={content.expandedTwo} />
                </p>
                {/* <div className="new-about__highlight"> */}
                  <h3 className="new-about__highlight-title">Ce am făcut?</h3>
                  <p className="new-about__text">
                    <FormattedMainPageText text={content.expandedThree} />
                  </p>
                {/* </div> */}
                <p className="new-about__text">
                  <FormattedMainPageText text={content.expandedFour} />
                </p>
                <p className="new-about__text">
                  <FormattedMainPageText text={content.expandedFive} />
                </p>
                <p className="new-about__text">
                  <FormattedMainPageText text={content.expandedSix} />
                </p>
                <p className="new-about__text">
                  <FormattedMainPageText text={content.expandedSeven} />
                </p>
                <p className="new-about__text">
                  <FormattedMainPageText text={content.expandedEight} />
                </p>
              </div>
            )}

            <button
              className="new-about__btn"
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
            >
              {expanded ? "Citește mai puțin" : "Citește mai mult"}
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                style={{ transform: expanded ? "rotate(-90deg)" : "none", transition: "transform 0.3s ease" }}
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BloomAbout;
